/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_CustomizeInputs */

const en_admin_resource_form_customize = /** @type {(inputs: Admin_Resource_Form_CustomizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customize`)
};

const de_admin_resource_form_customize = /** @type {(inputs: Admin_Resource_Form_CustomizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andere Konditionen für externe Buchungen einrichten`)
};

const es_admin_resource_form_customize = /** @type {(inputs: Admin_Resource_Form_CustomizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalizar para recurso público`)
};

const fr_admin_resource_form_customize = /** @type {(inputs: Admin_Resource_Form_CustomizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personnaliser pour ressource publique`)
};

/** @type {(inputs: Admin_Resource_Form_CustomizeInputs) => LocalizedString} */
const it_admin_resource_form_customize = en_admin_resource_form_customize;

/** @type {(inputs: Admin_Resource_Form_CustomizeInputs) => LocalizedString} */
const pt_br2_admin_resource_form_customize = en_admin_resource_form_customize;

/** @type {(inputs: Admin_Resource_Form_CustomizeInputs) => LocalizedString} */
const pl_admin_resource_form_customize = en_admin_resource_form_customize;

/** @type {(inputs: Admin_Resource_Form_CustomizeInputs) => LocalizedString} */
const hu_admin_resource_form_customize = en_admin_resource_form_customize;

/** @type {(inputs: Admin_Resource_Form_CustomizeInputs) => LocalizedString} */
const ro_admin_resource_form_customize = en_admin_resource_form_customize;

/**
* | output |
* | --- |
* | "Customize" |
*
* @param {Admin_Resource_Form_CustomizeInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_customize = /** @type {((inputs?: Admin_Resource_Form_CustomizeInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_CustomizeInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_customize(inputs)
	if (locale === "de") return de_admin_resource_form_customize(inputs)
	if (locale === "es") return es_admin_resource_form_customize(inputs)
	if (locale === "fr") return fr_admin_resource_form_customize(inputs)
	if (locale === "it") return it_admin_resource_form_customize(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_customize(inputs)
	if (locale === "pl") return pl_admin_resource_form_customize(inputs)
	if (locale === "hu") return hu_admin_resource_form_customize(inputs)
	return ro_admin_resource_form_customize(inputs)
});
export { admin_resource_form_customize as "admin.resource_form.customize" }